/**
 * Leitura dos anexos de uma resposta rápida.
 *
 * O formato atual é o array `medias` (tabela QuickMessageMedias, N anexos).
 * O formato legado eram as colunas mediaPath/mediaName (1 anexo só), que o
 * backend ainda mantém espelhadas com o primeiro item — por isso o array tem
 * precedência: se ele existir, usar o legado duplicaria o primeiro anexo.
 *
 * O ramo legado só é exercido em bancos onde o SQL de migração ainda não rodou.
 */
export const getQuickMessageMedias = (quickMessage) => {
    if (Array.isArray(quickMessage?.medias) && quickMessage.medias.length > 0) {
        return quickMessage.medias;
    }

    if (quickMessage?.mediaPath) {
        return [
            {
                id: null,
                mediaPath: quickMessage.mediaPath,
                mediaName: quickMessage.mediaName,
                mediaType: null,
            },
        ];
    }

    return [];
};

// Limite de anexos por resposta rápida (espelha MAX_QUICKMESSAGE_MEDIAS no backend).
export const MAX_QUICKMESSAGE_MEDIAS = 10;

export default getQuickMessageMedias;
